const reasons = [
  {
    icon: "ri-search-eye-line",
    title: "Product Discovery",
    description: "Find products faster with organized Vigorbuy spreadsheet categories. Skip the endless scrolling and go straight to curated collections updated regularly.",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20scene%20of%20a%20person%20browsing%20fashion%20products%20on%20a%20laptop%20with%20sneakers%20and%20accessories%20visible%20nearby%20on%20a%20light%20cream%20desk%2C%20soft%20natural%20window%20lighting%20with%20gentle%20shadows%2C%20conveying%20effortless%20product%20discovery%20and%20organized%20online%20shopping%2C%20editorial%20lifestyle%20photography%20with%20warm%20earthy%20tones%20and%20clean%20composition&width=600&height=400&seq=why-discovery-02&orientation=landscape",
  },
  {
    icon: "ri-folders-line",
    title: "Category Organization",
    description: "Browse structured collections across 14 product categories. From Shoes to Perfumes, every item is logically grouped for effortless navigation.",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20flatlay%20of%20neatly%20organized%20fashion%20product%20cards%20and%20labels%20arranged%20in%20clear%20sections%20on%20a%20light%20cream%20textured%20surface%2C%20soft%20natural%20lighting%20with%20gentle%20shadows%2C%20conveying%20structured%20category%20organization%20and%20easy%20navigation%2C%20editorial%20aesthetic%20with%20warm%20earthy%20tones%20and%20clean%20composition&width=600&height=400&seq=why-organization-02&orientation=landscape",
  },
  {
    icon: "ri-scales-3-line",
    title: "Buying Confidence",
    description: "Compare products side by side before purchasing. Access QC photos, reviews, and community feedback to make informed shopping decisions.",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20scene%20of%20two%20similar%20fashion%20products%20placed%20side%20by%20side%20for%20comparison%20on%20a%20light%20cream%20surface%20with%20a%20checklist%20and%20notes%20nearby%2C%20soft%20natural%20window%20lighting%20with%20gentle%20shadows%2C%20conveying%20confident%20product%20comparison%20and%20informed%20purchasing%2C%20editorial%20lifestyle%20photography%20with%20warm%20earthy%20tones&width=600&height=400&seq=why-confidence-02&orientation=landscape",
  },
  {
    icon: "ri-shield-flash-line",
    title: "Safety Awareness",
    description: "Learn secure shopping practices and how to avoid counterfeit products. Our safety guidelines help you navigate the Vigorbuy spreadsheet ecosystem safely.",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20scene%20of%20a%20shield%20icon%20beside%20carefully%20inspected%20fashion%20products%20including%20a%20bag%20and%20accessories%20on%20a%20light%20cream%20surface%20with%20soft%20natural%20lighting%2C%20conveying%20secure%20online%20shopping%20and%20consumer%20protection%2C%20editorial%20product%20photography%20with%20warm%20earthy%20tones%20and%20clean%20composition&width=600&height=400&seq=why-safety-02&orientation=landscape",
  },
];

export default function WhySection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Why Thousands Search for{" "}
            <span className="text-primary-500">Vigorbuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            The Vigorbuy spreadsheet has become an essential tool for savvy shoppers worldwide. Here is why so many people rely on it every day.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={reason.image}
                  alt={reason.title}
                  title={`${reason.title} - Vigorbuy Spreadsheet`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-3 group-hover:bg-primary-200/70 transition-colors">
                  <i className={`${reason.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{reason.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}